import React from 'react'
import PropTypes from 'prop-types'
import Select from 'react-select'
import { isEqual } from 'lodash'
import { fnum, sortOpts } from '../../utils/utils'
import SetsAddCompForm from '../settings/SetsAddCompForm'
import Form from '../ui/Form'

export default class PRSAddCostForm extends Form {

  static propTypes = {
    editPost: PropTypes.func.isRequired,
    cancelAdd: PropTypes.func.isRequired,
    updtBlnc: PropTypes.func.isRequired,
    srvgs: PropTypes.object.isRequired,
    data: PropTypes.object.isRequired
  }

  constructor(props){
    super(props);
    this.state = {
      data: props.data,
      showCreateComp: false,
      errors: {}
    };
  }

  savePost = e => {
    e.preventDefault();
    const { data } = this.state;
    if(isEqual(this.props.data, data)) {
      this.props.cancelAdd();
    }
    else {
      this.props.editPost(data, err => {
        if (err) {
          this.setState({errors: err});
          return;
        }
        this.props.cancelAdd();
        const diff = data.post_price * data.post_qntt;
        this.props.updtBlnc(0, 0, diff);
      });
    }
  }

  showCreateComp = () => {
    this.setState({
      showCreateComp:true
    });
  }

  hideCreateComp = () => {
    this.setState({
      showCreateComp:false
    });
  }

  selectAddedComp = id => {
    this.setState({
      data:{
        ...this.state.data,
        post_seller: id
      }
    });
  }

  render(){
    const { srvgs, ctypes, comps } = this.props;

    const { data, errors } = this.state;

    const showCreateComp = this.state.showCreateComp ?
      <SetsAddCompForm
        afterSave={this.selectAddedComp}
        addSets={this.props.addSets}
        onCancel={this.hideCreateComp}
        srvgs={srvgs}
        ctypes={ctypes}
        data={{
          comp_desc: '',
          comp_long: '',
          comp_city: '',
          comp_addr: '',
          comp_tel: '',
          comp_email: '',
          comp_note: '',
          comp_own: 0,
          comp_order: 0,
          comp_expense: 0,
          comp_cost: 1,
          comp_empl: 0,
          comp_ctype_id: 0,
          comp_srvg_ids: '',
          comp_active: 1
        }}
      />
      : '';

    var compsOpt = [];
    for (let key in comps){
      if(comps.hasOwnProperty(key) && comps[key].comp_active === 1
        && comps[key].comp_cost === 1) {
        compsOpt.push({value:comps[key].comp_id,label:comps[key].comp_desc});
      }
    }
    compsOpt.sort(sortOpts);

    return (
      <div
        className="modal"
        style={{
          paddingTop:'15%',
          overflowY:'visible',
          backgroundColor: 'rgba(30,30,30,.7)',
          display:'block'
        }}
      >
        {showCreateComp}
        <div
          className="modal-admin modal-m"
          style={{margin: 'auto', maxWidth: '90%'}}
        >
          <div className="modal-content">
            <div className="modal-header">
              <h4 style={{margin:0}}>Добавить подряд для {this.props.data.post_desc}</h4>
            </div>
            <div className="modal-body">
              <div className="row">
                <div className="col-xs-4">
                  <div className="form-group">
                    <textarea type="text"
                      className="form-control"
                      name="post_desc"
                      value={data.post_desc}
                      rows="3"
                      title="Описание"
                      placeholder="Описание"
                      onChange={this.updateInput}
                    />
                  </div>
                  <div className="form-group">
                    <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
                      <label>Подрядчик&nbsp;</label>
                      <div style={{flex: 1, width: 0}}>
                        <Select
                          clearable={false}
                          options={compsOpt}
                          value={data.post_seller}
                          onChange={e => this.updateSelect(e,'post_seller')}
                        />
                      </div>
                      <button type="button" className="btn btn-default"
                        onClick={this.showCreateComp}
                        title="Создать подрядчика"
                      >
                        <span className="glyphicon glyphicon-plus"></span>
                      </button>
                    </div>
                  </div>
                </div>
                <div className="col-xs-1">
                  <input type="text"
                    className="form-control text-editable"
                    value={data.post_price}
                    name="post_price"
                    onChange={this.updateInput}
                  />
                </div>
                <div className="col-xs-1">
                  <input type="text"
                    className="form-control text-editable"
                    value={data.post_qntt}
                    name="post_qntt"
                    onChange={this.updateInput}
                  />
                </div>
                <div className="col-xs-1">
                  {fnum(data.post_price*data.post_qntt)}
                </div>
                <div className="col-xs-5">
                  <textarea type="text"
                    className="form-control"
                    value={data.post_note}
                    rows="3"
                    placeholder="Заметка"
                    title="Заметка"
                    name="post_note"
                    onChange={this.updateInput}
                  />
                </div>
              </div>
              <button
                type="button"
                className="btn btn-default"
                onClick={this.props.cancelAdd}
              >Отмена</button>{" "}
              <button
                type="button"
                className="btn btn-success"
                onClick={this.savePost}
              >Сохранить</button>
              {errors.form && <div className="alert alert-danger">{errors.form}</div>}
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/prs/PRSAddCostForm.js